import { createContext, useContext, type ReactNode } from 'react'
import { useSFUCall } from '../hooks/useSFUCall'

export type CallState = ReturnType<typeof useSFUCall>

const CallContext = createContext<CallState | null>(null)

export function CallProvider({ children }: { children: ReactNode }) {
  const call = useSFUCall()
  return (
    <CallContext.Provider value={call}>
      {children}
    </CallContext.Provider>
  )
}

export function useCallContext(): CallState {
  const ctx = useContext(CallContext)
  if (!ctx) throw new Error('useCallContext must be used within CallProvider')
  return ctx
}
